// extracted by mini-css-extract-plugin
export var active = "_ll-e";
export var blink = "_ll-f";
export var dropDownSelector = "_ll-5";
export var dropDownWrapper = "_ll-4";
export var fakeCursor = "_ll-d";
export var fontSizeButton = "_ll-7";
export var formQuillEditor = "_ll-0";
export var pressed = "_ll-g";
export var qlBlank = "_ll-1";
export var textFormattingToolbar = "_ll-2";
export var textFormattingToolbarClosed = "_ll-3";
export var textFormattingToolbarInline = "_ll-6";
export var textToolbarOption = "_ll-8";
export var toolbarCell = "_ll-a";
export var toolbarCellCollapsed = "_ll-b";
export var toolbarOptionHitArea = "_ll-c";
export var toolbarOverflow = "_ll-9";